import React from 'react';

export const LikeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="120px" height="60px" viewBox="0 0 64 64">
    <g id="ARTWORK">
      <path
        fill="#e5af9f"
        d="M44,26a1.98718,1.98718,0,0,1,.06158-.47046c-7.50293-1.83478-13.527-8.91522-15.5371-16.19263a3.99847,3.99847,0,0,0-7.37977-.88317,10.80961,10.80961,0,0,0-.49,1.05157,9.70259,9.70259,0,0,0-.12225,6.6792L24,26H12a4,4,0,0,0-4,4v2a4,4,0,0,0,4,4h2a4,4,0,0,0-4,4v2a4,4,0,0,0,4,4h4a4,4,0,0,0-4,4v2a4,4,0,0,0,4,4H44"
      />
      <path
        fill="#099"
        d="M54,24H46a1.99657,1.99657,0,0,0-1.93842,1.52954L44,26V56H56V26A2,2,0,0,0,54,24ZM50,52a3,3,0,1,1,3-3A3,3,0,0,1,50,52Z"
      />
    </g>
    <g id="White_space" data-name="White space">
      <rect fill="none" width="64" height="64" />
    </g>
  </svg>
);
